var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"data-testid":"badge-click-wrapper"},on:{"click":_vm.onClick}},[_c('gl-badge',{staticClass:"version-check-badge",attrs:{"href":_vm.badgeUrl,"variant":_vm.status,"size":_vm.size}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }